import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { DEFAULT_COMPANY } from "./data";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ContentContext = createContext(null);

export const useContent = () => useContext(ContentContext);

export function ContentProvider({ children }) {
  const [company, setCompany] = useState(DEFAULT_COMPANY);
  const [services, setServices] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [projects, setProjects] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios.get(`${API}/content`).then(({ data }) => {
      if (data.settings) setCompany({ ...DEFAULT_COMPANY, ...data.settings });
      setServices(data.services || []);
      setTestimonials(data.testimonials || []);
      setGallery(data.gallery || []);
      setProjects(data.projects || []);
      setLoaded(true);
    }).catch(() => setLoaded(true));
  }, []);

  return (
    <ContentContext.Provider value={{ company, services, testimonials, gallery, projects, loaded }}>
      {children}
    </ContentContext.Provider>
  );
}
